export enum StationRole {
  ADMIN = "admin",
  OPERATOR = "operator",
  VIEWER = "viewer",
}

export enum SystemRole {
  SUPERADMIN = "superadmin",
  USER = "user",
}

export type TimeRange = "1h" | "6h" | "24h" | "7d" | "30d" | "custom";

export enum DeviceChannelEnum {
  CHANNEL_1 = "CHANNEL_1",
  CHANNEL_2 = "CHANNEL_2",
}

export enum DeviceConnectionTypeEnum {
  WIFI = "WIFI",
  LORAWAN = "LORAWAN",
}

export enum ActuatorRuleTypeEnum {
  THRESHOLD = "THRESHOLD",
  SCHEDULE = "SCHEDULE",
}

export enum ActuatorControlModeEnum {
  THRESHOLD = "THRESHOLD",
  SCHEDULE = "SCHEDULE",
}

export enum ActuatorActionEnum {
  ON = "ON",
  OFF = "OFF",
}

export interface SelectOption {
  value: string;
  label: string;
}
